import { formatLocalizedNumber } from '@/helpers/Number/FormatLocalizedNumber';
import { PriceValue, PriceValueResponse } from '@/models/queries/getPriceValue';
import { PropertyType } from '@/types';
import { HgSupportedLanguage } from '@smg-real-estate/domus';

export interface MedianPriceDataItem {
  price: string | null;
  range: {
    min: string | null;
    max: string | null;
  };
  date: string | null;
}

export type MedianPriceData = {
  [key in PropertyType]: MedianPriceDataItem;
};

export const getDefaultPriceValue = (): MedianPriceDataItem => ({
  price: null,
  range: {
    min: null,
    max: null,
  },
  date: null,
});

const dateFormatter = (dateValue: number | null): string => {
  if (!dateValue) {
    return '';
  }

  const dateStr = dateValue.toString();
  const matchResult = dateStr.match(/(\d{4})(\d{2})(\d{2})/);

  if (matchResult) {
    const [year, month, day] = matchResult.slice(1);
    return `${day}.${month}.${year}`;
  } else {
    return '';
  }
};

const getPriceData = (
  priceData: Array<PriceValue> | null | undefined,
  rounded: boolean,
  locale: HgSupportedLanguage,
): MedianPriceDataItem => {
  const priceItemData = priceData?.[0];
  return {
    price: formatLocalizedNumber(priceItemData?.priceValueMedian, rounded, locale),
    range: {
      min: formatLocalizedNumber(priceItemData?.priceRangeMin, rounded, locale),
      max: formatLocalizedNumber(priceItemData?.priceRangeMax, rounded, locale),
    },
    date: dateFormatter(priceItemData?.priceDate ?? null),
  };
};

const adaptData = (
  data: PriceValueResponse,
  rounded = false,
  locale: HgSupportedLanguage = HgSupportedLanguage.DE,
): MedianPriceData => {
  return {
    [PropertyType.Apartment]: getPriceData(
      data?.results?.[PropertyType.Apartment],
      rounded,
      locale,
    ),
    [PropertyType.House]: getPriceData(data?.results?.[PropertyType.House], rounded, locale),
  };
};
export default adaptData;
